import { debugRoot } from '../../../../styles/debugStyles';
var itemLayoutStyles = {
  root: function root(_ref) {
    var props = _ref.props,
        variables = _ref.variables;
    var debugLayout = props.debugLayout;
    return Object.assign({}, debugLayout && debugRoot(), {
      gridTemplateRows: "minmax(".concat(variables.height, ", max-content)"),
      paddingLeft: variables.paddingLeft,
      paddingRight: variables.paddingRight
    });
  }
};
export default itemLayoutStyles;